const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const isValidPattern = (pattern: RegExp, value: string) => {
  const flags = pattern.flags.replace("g", "");
  const regex = new RegExp(pattern.source, flags);

  return regex.test(value);
};

export const FORM_UNIT_TYPE_ELEMENT_FIELDS = [
  // ---------- Unit Details (left column) ----------
  {
    id: "unitTypeName",
    label: "Type Name",
    placeHolder: "",
    type: "text",
    md: 4,
    section: "unitDetails",
    maxLength: 50,  // ✅ Max 50 characters
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "storageType",
    label: "Storage Type",
    placeHolder: "Select",
    type: "select",
    options: ["Room", "Crate", "Pallet", "Shelves", "Containers"],
    md: 4,
    section: "unitDetails",
    isRequired: true,
  },
  {
    id: "sizeFt3",
    label: "Size (ft³)",
    placeHolder: "Enter size",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits for size
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 4,
    section: "unitDetails",
  },
  // ---------- Dimensions (right column, top) ----------
  {
    id: "unitWidth",
    label: "Width (ft)",
    placeHolder: "Enter width",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 4,
    section: "dimensions",
  },
  {
    id: "unitLength",
    label: "Length (ft)",
    placeHolder: "Enter length",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 4,
    section: "dimensions",
  },
  {
    id: "unitHeight",
    label: "Height (ft)",
    placeHolder: "Enter height",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 4,
    section: "dimensions",
  },
  {
    id: "quantity",
    label: "Quantity",
    placeHolder: "Enter quantity",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits for quantity
    patternAllowed: patternConstant?.NUMERIC,
    isRequired: true,
    md: 4,
    section: "unitDetails",
  },
  {
    id: "rentType",
    label: "Rent Type",
    placeHolder: "Select",
    type: "select",
    options: ["Monthly", "Weekly"],
    md: 4,
    section: "unitDetails",
    isRequired: true,
  },
  {
    id: "unitNumbering",
    label: "Unit Numbering / Ref No.",
    placeHolder: "Select",
    type: "select",
    options: ["Sequential Numbering"],
    md: 4,
    section: "unitDetails",
    // isRequired: true,
  },
  {
    id: "prefix",
    label: "Prefix (Max. 5 letters)",
    placeHolder: "e.g. RM001",
    type: "text",
    maxLength: 5,  // ✅ Max 5 characters
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    md: 4,
    section: "unitDetails",
  },
  // {
  //   id: "pricePerUnit",
  //   label: "Price Per Unit",
  //   placeHolder: "0.00",
  //   type: "text",
  //   maxLength: 8,  // ✅ Max 8 digits (includes decimals)
  //   patternAllowed: patternConstant?.PRICE,
  //   isRequired: true,
  //   md: 4,
  //   section: "unitDetails",
  // },

  {
    id: "securityDepositType",
    label: "Security Deposit",
    type: "select",
    options: ["Amount", "Percentage"],
    md: 4,
    section: "unitDetails",
  },
  {
    id: "securityDepositValue",
    label: "Security Deposit Value",
    placeHolder: "Enter security deposit value",
    type: "text",
    maxLength: 12,  // ✅ Max 12 digits (includes decimals)
    patternAllowed: patternConstant?.PRICE,
    md: 4,
    section: "unitDetails",
  },
  {
    id: "siteAccessHours",
    label: "Site Access Hours",
    type: "select",
    options: ["24 Hours", "Custom", "Closed"],
    md: 4,
    section: "unitDetails",
  },
  {
    id: "accessStartTime",
    label: "Start Time",
    placeHolder: "Select start time",
    type: "time",
    md: 2,
    section: "unitDetails",
    isRequired: true,
    dependsOn: { field: "siteAccessHours", value: "Custom" },
  },
  {
    id: "accessEndTime",
    label: "End Time",
    placeHolder: "Select end time",
    type: "time",
    md: 2,
    section: "unitDetails",
    isRequired: true,
    dependsOn: { field: "siteAccessHours", value: "Custom" },
  },
];

export const FORM_ELEMENT_FIELDS = [
  // ---------- Unit Details (left column) ----------
  {
    id: "unitTypeId",
    label: "Unit Type Name",
    placeHolder: "",
    type: "select",
    md: 4,
    options: [],
    section: "unitDetails",
    maxLength: 50,  // ✅ Max 50 characters
    isRequired: true,
  },

  {
    id: "sizeFt3",
    label: "Size (ft³)",
    placeHolder: "Enter size",
    type: "text",
    maxLength: 9,  // ✅ Max 9 digits
    patternAllowed: patternConstant?.PRICE,
    md: 4,
    section: "unitDetails",
    disabled:true
  },
  {
    id: "quantity",
    label: "Quantity",
    placeHolder: "Enter quantity",
    type: "text",
    maxLength: 5,  // ✅ Max 5 digits
    patternAllowed: patternConstant?.NUMERIC,
    isRequired: true,
    md: 4,
    section: "unitDetails",
  },
  {
    id: "rentType",
    label: "Rent Type",
    placeHolder: "Select",
    // type: "select",
    options: ["Monthly", "Weekly"],
    md: 4,
    section: "unitDetails",
    disabled:true
  },
  {
    id: "unitNumbering",
    label: "Unit Numbering / Ref No.",
    // placeHolder: "Select",
    type: "select",
    options: ["Sequential Numbering"],
    md: 4,
    section: "unitDetails",
    isRequired: true,
    isEditableHide:true
  },
  {
    id: "prefix",
    label: "Prefix (Max. 5 letters)",
    placeHolder: "e.g. RM001",
    type: "text",
    maxLength: 5,  // ✅ Max 5 characters
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
    section: "unitDetails",
    isEditableHide:true
  },
  {
    id: "rangeStart",
    label: "Start Range",
    placeHolder: "Enter width",
    type: "text",
    maxLength: 9,  // ✅ Max 9 digits
    patternAllowed: patternConstant?.PRICE,
    md: 2,
    section: "unitDetails",
    isEditableHide:true
  },
  {
    id: "rangeEnd",
    label: "End Range",
    placeHolder: "Enter width",
    type: "text",
    maxLength: 9,  // ✅ Max 9 digits
    patternAllowed: patternConstant?.PRICE,
    md: 2,
    section: "unitDetails",
    isEditableHide:true
  },
  {
    id: "pricePerUnit",
    label: "Price Per Unit",
    placeHolder: "0.00",
    type: "text",
    maxLength: 12,  // ✅ Max 12 digits (includes decimals)
    patternAllowed: patternConstant?.PRICE,
    // isDisabled: true,
    md: 4,
    isRequired: true,
    section: "unitDetails",
    // disabled:true
  },

  // ---------- Dimensions (right column, top) ----------
  {
    id: "unitWidth",
    label: "Width (ft)",
    placeHolder: "Enter width",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits
    patternAllowed: patternConstant?.PRICE,
    md: 4,
    section: "dimensions",
    disabled:true
  },
  {
    id: "unitLength",
    label: "Length (ft)",
    placeHolder: "Enter length",
    type: "text",
    maxLength: 6,  // ✅ Max 6 digits
    patternAllowed: patternConstant?.PRICE,
    // isRequired: true,
    md: 4,
    section: "dimensions",
    disabled:true
  },
  {
    id: "unitHeight",
    label: "Height (ft)",
    placeHolder: "Enter height",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    // isRequired: true,
    md: 4,
    section: "dimensions",
    disabled:true
  },
  {
    id: "securityDepositType",
    label: "Security Deposit",
    type: "select",
    options: ["Amount", "Percentage"],
    md: 4,
    section: "unitDetails",
    disabled:true
  },
  {
    id: "securityDepositValue",
    label: "Security Deposit Value",
    placeHolder: "Enter security deposit value",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    // isRequired: true,
    md: 4,
    section: "unitDetails",
    disabled:true
  },
  {
    id: "siteAccessHours",
    label: "Site Access Hours",
    type: "select",
    options: ["24 Hours", "Custom", "Closed"],
    md: 4,
    section: "unitDetails",
    disabled:true,
     isEditableHide:true
  },
    {
    id: "accessStartTime",
    label: "Start Time",
    placeHolder: "Select start time",
    type: "time",
    md: 2,
     section: "unitDetails",
    isRequired: true,
    dependsOn: { field: "siteAccessHours", value: "Custom" },
  },
  {
    id: "accessEndTime",
    label: "End Time",
    placeHolder: "Select end time",
    type: "time",
    md: 2,
     section: "unitDetails",
    isRequired: true,
    dependsOn: { field: "siteAccessHours", value: "Custom" },
  },
  // {
  //   id: "time_range",
  //   label: "Set Time Range",
  //   placeHolder: "e.g. 08:00 AM",
  //   type: "timerange", // or "text" if FormField doesn't support a time type
  //   md: 4,
  //   section: "unitDetails",
  //   dependsOn: { field: "siteAccessHours", value: "Custom" },
  //   // isRequired: true,
  // },
];

export const unitSummary = [
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
  {
    type_name: "Standard Room",
    storage_type: "Room",
    size: "100 sq ft",
    qunatity: 10,
    price: "12.00/Month",
  },
];
